import {
  ActivitiesPageFilters,
  DurationFilter,
} from "domain/entities/activities.entities";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Tutorials } from "ui/pages/app/tutorials/Tutorials";
import { Tutorial } from "ui/pages/app/tutorials/tutorial/Tutorial";

export default function TutorialsContainer() {
  const [searchParams] = useSearchParams();
  const [filters, setFilters] = useState<
    ActivitiesPageFilters & {
      [key: string]: string | string[] | boolean | DurationFilter | number;
    }
  >({
    categories: [],
  });

  return searchParams.get("id") || searchParams.get("innizRef") ? (
    <Tutorial
      selectedTutorialId={searchParams.get("id")}
      innizRef={searchParams.get("innizRef")}
    />
  ) : (
    <Tutorials filters={filters} setFilters={setFilters} />
  );
}
